import FragmentDataType from "../enums/fragment-data-type";
import Fumble from "./fumble";
import FragmentSummary from "./fragment-summary";
import { FragmentMessages } from "../../common/fragment-messages";
import PatResultType from "../enums/pat-result-type";

export default class FieldGoalFumble extends Fumble {
    constructor(kickedTo, forcedBy) {
        super(forcedBy);
        this.code = "B"; // TODO: We should consider adding a new code to Legacy Stats for Field Goal Fumbles
        this.patCode = PatResultType.FUMBLED.code;
        this.kickedTo = kickedTo;

        this.requiredData = [
            {
                name: "kickedTo",
                type: FragmentDataType.FieldPosition,
                displayName: "Kicked To",
                title: "Kicked To",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION
            },
            {
                name: "forcedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Forced by",
                title: (team) => `Forced By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const message = ` ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.kickedTo,
            false
        )},
			fumble forced by ${stringifier.firstInitial(this.forcedBy)},
			fumble by ${stringifier.firstInitial(summaryContext.playerInPossession)}
			`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.fieldPosition = this.kickedTo;
    }
}
